export default function($) {
  const mobileBreakpoint = 1024;
  let eventListeners = [];

  const cleanupMobileMenu = () => {
    eventListeners.forEach(({element, type, handler}) => {
      element.removeEventListener(type, handler);
    });
    eventListeners = [];

    document.querySelectorAll('.menu-item--hidden').forEach(item => {
      item.classList.remove('menu-item--hidden');
    });
    document.querySelectorAll('.menu-item-has-children--active').forEach(item => {
      item.classList.remove('menu-item-has-children--active');
    });
    document.querySelectorAll('.menu-back-item').forEach(item => {
      item.remove();
    });

    const mobileMenu = document.querySelector('.js-nav-mobile-menu');
    if (mobileMenu && mobileMenu.classList.contains('is-open')) {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };

  const addEventListenerWithCleanup = (element, type, handler) => {
    element.addEventListener(type, handler);
    eventListeners.push({element, type, handler});
  };

  const initMobileMenu = () => {
    cleanupMobileMenu();

    if (window.innerWidth >= mobileBreakpoint) return;

    const menuTrigger = document.querySelector('.js-menu-mobile-nav-trigger');
    const menuClose = document.querySelector('.js-nav-mobile-close');
    const mobileMenu = document.querySelector('.js-nav-mobile-menu');
    const menuItems = document.querySelectorAll('.nav .menu-item-has-children');

    const hideMenuItems = (activeItem) => {
      document.querySelectorAll('.nav li').forEach(item => {
        item.classList.remove('menu-item--hidden');
      });

      if (activeItem) {
        document.querySelectorAll('.nav li').forEach(item => {
          if (!item.contains(activeItem) && !activeItem.contains(item)) {
            item.classList.add('menu-item--hidden');
          }
        });
      }
    };

    addEventListenerWithCleanup(menuTrigger, 'click', () => {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    addEventListenerWithCleanup(menuClose, 'click', () => {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
      hideMenuItems(null);
      document.querySelectorAll('.menu-item-has-children--active').forEach(item => {
        item.classList.remove('menu-item-has-children--active');
      });
    });

    menuItems.forEach(menuItem => {
      const link = menuItem.querySelector('a');
      const subMenu = menuItem.querySelector('.sub-menu');

      if (subMenu && link) {
        const menuTitle = link.querySelector('.menu-item-title').textContent;

        const backLi = document.createElement('li');
        backLi.className = 'menu-back-item';
        backLi.innerHTML = `
          <a href="#">
            <span class="menu-item-title">${menuTitle}</span>
          </a>
        `;

        subMenu.insertBefore(backLi, subMenu.firstChild);

        const linkClickHandler = (e) => {
          e.preventDefault();
          document.querySelectorAll('.menu-item-has-children--active').forEach(item => {
            item.classList.remove('menu-item-has-children--active');
          });
          menuItem.classList.add('menu-item-has-children--active');
          hideMenuItems(menuItem);
        };

        const backClickHandler = (e) => {
          e.preventDefault();
          menuItem.classList.remove('menu-item-has-children--active');
          const parentMenuItem = menuItem.parentNode.closest('.menu-item-has-children');
          if (parentMenuItem) {
            parentMenuItem.classList.add('menu-item-has-children--active');
            hideMenuItems(parentMenuItem);
          } else {
            hideMenuItems(null);
          }
        };

        addEventListenerWithCleanup(link, 'click', linkClickHandler);
        addEventListenerWithCleanup(backLi.querySelector('a'), 'click', backClickHandler);
      }
    });
  };

  initMobileMenu();
  window.addEventListener('resize', initMobileMenu);
};
